import React from "react";
import "./Backdrop.css";
import { prefix } from "../../../scripts/helpers/constants";

const backdrop = props =>
  props.show ? (
    <div className={prefix + "-c-backdrop"} onClick={props.clicked} />
  ) : null;

export default backdrop;



// WEBPACK FOOTER //
// ./src/components/UI/Backdrop/Backdrop.js